const unitsInit = {
  items:{},
  pending:false,
  fulfilled:false,
  error:""
};
export default unitsInit;
